"use strict";

exports.__esModule = true;
exports.getmsharecommon = exports.apiGetmoreitemcomponenth5 = void 0;
var _fetch = require("../../utils/fetch");
/**
 * 获取公共操作项
 */
var apiGetmoreitemcomponenth5 = function apiGetmoreitemcomponenth5(params) {
  if (params === void 0) {
    params = {};
  }
  return (0, _fetch.fetch)({
    url: '//app.zhuanzhuan.com/zzopen/userplatform/getmoreitemcomponenth5',
    method: 'get',
    params: params
  }).then(function (res) {
    return res.respData || null;
  });
};
// 转短链接
exports.apiGetmoreitemcomponenth5 = apiGetmoreitemcomponenth5;
var getmsharecommon = function getmsharecommon(params) {
  if (params === void 0) {
    params = {};
  }
  return (0, _fetch.fetch)({
    url: '//app.zhuanzhuan.com/zz/transfer/getmsharecommon',
    method: 'get',
    params: params
  }).then(function (res) {
    return res.respData || null;
  });
};
exports.getmsharecommon = getmsharecommon;